export default __webpack_public_path__ + "a7e1d48c8f537b85d6d0f54169f44314.svg";